// this could also be done with a polyfill and a modern browser API
// https://stackoverflow.com/questions/979975/how-to-get-the-value-from-the-get-parameters/979995
export default function getQueryParams(qs: string) {
    qs = qs.split('+').join(' ');

    const params: Record<string, string> = {};
    let tokens;
    const re = /[?&]?([^=]+)=([^&]*)/g;

    while ((tokens = re.exec(qs))) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}
